import { useRouter } from 'next/router';
import { Container } from 'react-bootstrap';

import cx from 'classnames';

import { Link } from 'components/Layout';
import { useBI } from 'contexts/BIContext';

import { BIReportMenuIcon } from '../Icons';
import Nav from './Nav/Nav';

import s from './Header.module.scss';

interface IProps {
  title: string;
  backgroundImage?: string;
}

function Header({ title, backgroundImage }: IProps) {
  const {
    state: { showMenu },
    actions: { toggleMenu },
  } = useBI();
  const router = useRouter();
  const { pathname } = router;
  const isOnlineForm = [
    '/online-forms/[type]',
    '/online-forms/instructions',
    '/online-forms/qualifying-questions',
  ].includes(pathname);
  const isBIReports = pathname.toLowerCase() === '/bi-reports';

  const bgStyle = backgroundImage
    ? {
        backgroundImage: `url('${backgroundImage}')`,
      }
    : undefined;

  return (
    <div
      className={cx('flex-grow-0 flex-shrink-0', s.header, {
        [s.large]: pathname === '/',
        [s.small]: isOnlineForm || isBIReports,
        [s.hasBgImage]: !!backgroundImage,
      })}
      style={bgStyle}
    >
      <Container className={s.menu} fluid>
        <div className="d-flex align-items-center">
          {isBIReports && (
            <div className="mr-2 mr-md-4 ml-2 ml-md-0">
              <button
                className={cx(s.toggleBI, { [s.showMenu]: showMenu })}
                onClick={toggleMenu}
                type="button"
              >
                <BIReportMenuIcon />
              </button>
            </div>
          )}
          <Link href="/">
            <img
              src="/atlas_logo.png"
              alt="Atlas Insurance"
              className={`${s.pointer} m-4`}
            />
          </Link>
        </div>
        <Nav />
      </Container>

      {!isBIReports && (
        <Container>
          <h3 className={s.headerTitle}>{title}</h3>
        </Container>
      )}
    </div>
  );
}

export default Header;
